export default "__VITE_ASSET__BcmArp60__"